

<template>
    <div>
        <svgicon :key="action" v-for="(button, action) in buttons" :name="button.icon" v-on:click="$emit('action', action)"></svgicon>
    </div>
</template>
<script>
    import {actions} from '../../utils/actions';
    export default {
        name: 'ActionButtons',
        components: {},
        props: {
            links: {
                type: Object
            },
            exclude: {
                type: Array,
                default: function () { return [] }
            }
        },
        data () {
            return {
            }
        },
        computed: {
            buttons(){
                let self = this;
                const filtered = Object.keys(this.links)
                    .filter(key => !self.exclude.includes(key) && typeof actions[key] !== "undefined")
                    .reduce((obj, key) => {
                        obj[key] = actions[key];
                        return obj;
                    }, {});
                return filtered;
            }
        },
        mounted () {

        },
        methods: {
        }
    }

</script>
<style src="./ActionButtons.scss" scoped lang="scss"></style>

